const ReciboIcon = ({ width = 24, height = 24, color = '#111' }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} color={color} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" /><path d="M14 8H8" /><path d="M16 12H8" /><path d="M13 16H8" /></svg>
    )
}
export default ReciboIcon;